import {
  AtlasAttachmentLoader,
  SkeletonBinary,
  SkeletonJson,
  type SkeletonData,
  type TextureAtlas,
} from "@esotericsoftware/spine-pixi-v8";

/**
 * Parse loaded Spine assets into a shareable `SkeletonData`.
 * `Spine.from` does the same internally but always builds an instance; a HOST that pools many
 * instances per symbol wants the data alone. `skeleton` is whatever the loader produced for the
 * `.skeleton`/`.json` file (binary → `Uint8Array`, JSON → object or string).
 */
export function createSkeletonData(input: { skeleton: unknown; atlas: TextureAtlas; scale?: number }): SkeletonData {
  const attachmentLoader = new AtlasAttachmentLoader(input.atlas);
  const scale = input.scale ?? 1;
  const skeleton = input.skeleton;
  if (skeleton instanceof Uint8Array || skeleton instanceof ArrayBuffer) {
    const parser = new SkeletonBinary(attachmentLoader);
    parser.scale = scale;
    return parser.readSkeletonData(skeleton instanceof ArrayBuffer ? new Uint8Array(skeleton) : skeleton);
  }
  const parser = new SkeletonJson(attachmentLoader);
  parser.scale = scale;
  return parser.readSkeletonData(skeleton as string | object);
}
